import * as types from "./constant"

export const getSubLOBStart = () => {
  return {
    type: types.GET_SU_SUB_LOB_START,
  }
}
export const getSubLOBSuccess = payload => {
  return {
    type: types.GET_SU_SUB_LOB_SUCCESS,
    payload: payload,
  }
}
export const getSubLOBFail = payload => {
  return {
    type: types.GET_SU_SUB_LOB_FAILED,
    payload: payload,
  }
}
export const getSubLOBReset = () => {
  return {
    type: types.GET_SU_SUB_LOB_RESET,
  }
}

//Create SubLOB

export const CreateSubLOBStart = (payload) => {
    return {
      type: types.CREATE_SU_SUB_LOB_START,
      payload: payload
    }
  }
  export const CreateSubLOBSuccess = payload => {
    console.log(payload)
    return {
      type: types.CREATE_SU_SUB_LOB_SUCCESS,
      payload: payload,
    }
  }
  export const CreateSubLOBFail = payload => {
    return {
      type: types.CREATE_SU_SUB_LOB_FAILED,
      payload: payload,
    }
  }
  export const CreateSubLOBReset = () => {
    return {
      type: types.CREATE_SU_SUB_LOB_RESET,
    }
  }
  
  //Create SubLOB

export const UpdateSubLOBStart = (payload) => {
  console.log('SUB LOB :' + payload)
    return {
      type: types.UPDATE_SU_SUB_LOB_START,
      payload: payload
    }
  }
  export const UpdateSubLOBSuccess = payload => {
    return {
      type: types.UPDATE_SU_SUB_LOB_SUCCESS,
      payload: payload,
    }
  }
  export const UpdateSubLOBFail = payload => {
    return {
      type: types.UPDATE_SU_SUB_LOB_FAILED,
      payload: payload,
    }
  }
  export const UpdateSubLOBReset = () => {
    return {
      type: types.UPDATE_SU_SUB_LOB_RESET,
    }
  }


  // DELETE SubLOB :

  export const DeleteSubLOBStart = (payload) => {
    return {
      type: types.DEL_SU_SUB_LOB_START,
      payload: payload
    }
  }
  export const DeleteSubLOBSuccess = payload => {
    return {
      type: types.DEL_SU_SUB_LOB_SUCCESS,
      payload: payload,
    }
  }
  export const DeleteSubLOBFail = payload => {
    return {
      type: types.DEL_SU_SUB_LOB_FAILED,
      payload: payload,
    }
  }
  export const DeleteSubLOBReset = () => {
    return {
      type: types.DEL_SU_SUB_LOB_RESET,
    }
  }
